// extracted by mini-css-extract-plugin
export default {"container":"LocationsTabsFilter_container__LKItN","tab":"LocationsTabsFilter_tab__zcXdh","active":"LocationsTabsFilter_active__IVGZF"};